const handleVibrate = (): boolean => window.navigator?.vibrate && window.navigator.vibrate(500);

export default handleVibrate;
